/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorizationStatus,
  Status,
  UpdateSite,
  UpdateSiteResponse,
  UpdateSitesSearchRequest,
} from '../models';
import {
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    StatusFromJSON,
    StatusToJSON,
    UpdateSiteFromJSON,
    UpdateSiteToJSON,
    UpdateSiteResponseFromJSON,
    UpdateSiteResponseToJSON,
    UpdateSitesSearchRequestFromJSON,
    UpdateSitesSearchRequestToJSON,
} from '../models';

export interface CreateUpdateSiteRequest {
    updateSite: UpdateSite;
    authorization?: string;
    onBehalfOf?: string;
}

export interface DeleteUpdateSiteRequest {
    id: number;
    authorization?: string;
    onBehalfOf?: string;
}

export interface GetUpdateSiteRequest {
    id: number;
    authorization?: string;
    onBehalfOf?: string;
}

export interface SearchUpdateSiteRequest {
    updateSitesSearchRequest: UpdateSitesSearchRequest;
    authorization?: string;
    onBehalfOf?: string;
}

export interface UpdateUpdateSiteRequest {
    id: number;
    updateSite: UpdateSite;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class UpdateSitesApi extends runtime.BaseAPI {

    /**
     * Create update site.
     */
    async createUpdateSiteRaw(requestParameters: CreateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSiteResponse>> {
        if (requestParameters.updateSite === null || requestParameters.updateSite === undefined) {
            throw new runtime.RequiredError('updateSite','Required parameter requestParameters.updateSite was null or undefined when calling createUpdateSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/update-sites`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSiteToJSON(requestParameters.updateSite),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSiteResponseFromJSON(jsonValue));
    }

    /**
     * Create update site.
     */
    async createUpdateSite(requestParameters: CreateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSiteResponse> {
        const response = await this.createUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete update site.
     */
    async deleteUpdateSiteRaw(requestParameters: DeleteUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUpdateSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/update-sites/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Delete update site.
     */
    async deleteUpdateSite(requestParameters: DeleteUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.deleteUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get update site.
     */
    async getUpdateSiteRaw(requestParameters: GetUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSiteResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUpdateSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/update-sites/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSiteResponseFromJSON(jsonValue));
    }

    /**
     * Get update site.
     */
    async getUpdateSite(requestParameters: GetUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSiteResponse> {
        const response = await this.getUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search update site.
     */
    async searchUpdateSiteRaw(requestParameters: SearchUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSiteResponse>> {
        if (requestParameters.updateSitesSearchRequest === null || requestParameters.updateSitesSearchRequest === undefined) {
            throw new runtime.RequiredError('updateSitesSearchRequest','Required parameter requestParameters.updateSitesSearchRequest was null or undefined when calling searchUpdateSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/update-sites:search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSitesSearchRequestToJSON(requestParameters.updateSitesSearchRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSiteResponseFromJSON(jsonValue));
    }

    /**
     * Search update site.
     */
    async searchUpdateSite(requestParameters: SearchUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSiteResponse> {
        const response = await this.searchUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update update site.
     */
    async updateUpdateSiteRaw(requestParameters: UpdateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSiteResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUpdateSite.');
        }

        if (requestParameters.updateSite === null || requestParameters.updateSite === undefined) {
            throw new runtime.RequiredError('updateSite','Required parameter requestParameters.updateSite was null or undefined when calling updateUpdateSite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/update-sites/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSiteToJSON(requestParameters.updateSite),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSiteResponseFromJSON(jsonValue));
    }

    /**
     * Update update site.
     */
    async updateUpdateSite(requestParameters: UpdateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSiteResponse> {
        const response = await this.updateUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
